import React from 'react'
import { BrowserRouter as Router, Routes, Route, useParams, Navigate } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import Layout from './components/Layout'
import ProductPage from './components/ProductPage'
import AboutPage from './components/AboutPage'
import ContactPage from './components/ContactPage'
import LegalPage from './components/LegalPage'
import Home from './components/Home'
import { products } from './data/products'
import { ThemeProvider } from './context/ThemeContext'
import { LanguageProvider } from './context/LanguageContext'
import ScrollToTop from './components/ScrollToTop'

// Wrapper to pass product data based on ID
const ProductWrapper = () => {
  const { id } = useParams();
  const product = products.find(p => p.id === id);
  return <ProductPage product={product} />;
};

export default function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <LanguageProvider>
          <Router>
            <ScrollToTop />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/product/:id" element={<ProductWrapper />} />
                <Route path="/sobre-nosotros" element={<AboutPage />} />
                <Route path="/contacto" element={<ContactPage />} />
                <Route path="/legal" element={<LegalPage />} />

                {/* Redirects for legacy/broken URLs */}
                <Route path="/pages/contact" element={<Navigate to="/contacto" replace />} />
                <Route path="/fuengirola-brand" element={<Navigate to="/" replace />} />

                {/* Catch-all for 404s -> Redirect to Home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </Router>
        </LanguageProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}